<ion-button (click)="onAddToCalendar('google')" expand="block" fill="clear">
    Google Calendar
</ion-button>
<ion-button (click)="onAddToCalendar('outlook')" expand="block" fill="clear">
    Outlook Calendar
</ion-button>
